(function(){

	/*
		* Profile Pic
		*
		* Attributes:
		* @memberid {number} - member Id of the user to load a profile pic for
		* @type {string} - Type of profile pic expected; options: default, initials, portrait, gravatar, facebook, customimage
		* @size {string} - The size of the preview. Options are: medium, large, xlarge, custom
		* @imgsize {number} - specify an image size
		* @yoffset {number} - vertical offset for the image
		* @color {hex} - icon text color
		* @bgcolor {hex} - icon background color
		* @dataset {} - object with attributes bundled inside
		* @value {string} - Pass in static letters to use as the profile pic initials
		* @refresh {boolean} - Force an update when values are passed in
		* @imageonly {boolean} - when set to false we use the css version of the html
		*
		* Usage w/ Member Id: <profile-pic memberid="{{creatorinfo.parentid}}" color="{{themeinfo.buttontextcolor}}" bgcolor="{{themeinfo.buttoncolor}}"></profile-pic>
		* Usage w/ Static Initials: <profile-pic type="initials" value="JS" color="{{themeinfo.buttontextcolor}}" bgcolor="{{themeinfo.buttoncolor}}"></profile-pic>
	*/

	profilePic.$inject = ['httpService','globalJSService'];

	function profilePic( httpService, global ){
	    return {
	        restrict: 'E',
	        scope : {},
	        controller : function(){ return; },
	        link: function(scope, elem, attrs) {
	        	// secure url
	        	scope.secureURL = global.secureURL;
						// serve fresh image
	        	scope.refresh = Math.random();
	        	// add camera link
	        	scope.link = typeof attrs.link == 'undefined' ? false : attrs.link;
	        	// determine Retina status
	        	scope.isRetina = isRetina();
	        	// template variables
	        	scope.S3ImagesURI = global.S3ImagesURI;
	        	// required for member lookup
	        	scope.apiendpoint = global.apiendpoint;
	        	// portrait
	        	scope.defaultPortraitID = global.defaultPortraitID;
        		scope.size = !scope.isRetina ? 30 : 64;
        		scope.imgsize = 30;
        		scope.yoffset = -3;
        		if ( attrs.size == 'medium' ){
	        		scope.size = !scope.isRetina ? 64 : 128;
	        		scope.imgsize = 64;
	        		scope.yoffset = -6;
	        	} else if ( attrs.size == 'large' ){
	        		scope.size = !scope.isRetina ? 128 : 256;
	        		scope.imgsize = 128;
	        		scope.yoffset = -11;
	        	} else if ( attrs.size == 'xlarge' ){
	        		scope.size = 256;
	        		scope.imgsize = 256;
	        		scope.yoffset = -22;
	        	}
	        	else if( attrs.size == 'custom' && typeof attrs.imgsize != 'undefined' && typeof attrs.yoffset != 'undefined' ){
					// In order to get custom sizes to work, you also need to add the corresponding ppic classes for the imgsize to the _profilepic.scss file. Otherwise it will default to the ppic-30 css when displaying.

        			scope.size = 256; // use the largest size
            		scope.imgsize = attrs.imgsize;
            		scope.yoffset = attrs.yoffset;
        		}

        		// allow overwriting of settings if passed into directive
        		scope.yoffset = typeof attrs.yoffset == 'undefined' ? scope.yoffset : attrs.yoffset;
        		scope.color = typeof attrs.color == 'undefined' ? '#F68B1C' : attrs.color;
        		scope.bgcolor = typeof attrs.bgcolor == 'undefined' ? '#FFF590' : attrs.bgcolor;

				scope.defaultImageURI = encodeURIComponent( 'https://' + global.defaultimageURI + '/images/portraits/portrait'+scope.defaultPortraitID+'_'+ scope.size +'.png');

	        	attrs.$observe('dataset', function(v){
	        		var datasetobj = scope.$eval(attrs.dataset);
	        		if ( datasetobj && 'type' in datasetobj ){
	        			scope.type = datasetobj.type;
	            		scope.value = datasetobj.value;
	        		}
	            });

	            var mobileAndTabletcheck = function() {
				  var check = false;
				  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
				  return check;
				}

	        	attrs.$observe('value', function(v){
	        		if ( attrs.value ){
		                scope.type = attrs.type;
		                scope.value = attrs.value;
	        		}
	            });

				attrs.$observe('bgcolor', function(v){
	        		if ( typeof attrs.bgcolor !== 'undefined' ) {
						 scope.bgcolor = attrs.bgcolor;
					} else {
						scope.bgcolor = '#FFF590';
					};

	            });

				attrs.$observe('color', function(v){
	        		if ( typeof attrs.color !== 'undefined' ) {
						 scope.color = attrs.color;
					} else {
						scope.color = '#F68B1C';
					};

	            });

	        	attrs.$observe('memberid', function(v){
	        		if ( attrs.memberid ){
		        		httpService.post( scope.apiendpoint + '/profile/picByMember/', { "memberid" : attrs.memberid } )
		        		.then( function( result){
							scope.type = result.data.returnData.data.type;
							scope.value = result.data.returnData.data.value;
		        		});
	        		}
	            });

				// Observer for refresh attribute to ensure that it updates when a value is passed in to the directive
				attrs.$observe('refresh', function(v){
	        		if ( typeof attrs.refresh !== 'undefined' ) {
						scope.refresh = attrs.refresh;
					} else {
						scope.refresh = scope.refresh;
					};

				});

	        	scope.getContentUrl = function() {
	        		scope.type = scope.type ? scope.type : 'default';
	        		if ( attrs.imageonly == 'false' || typeof attrs.imageonly == 'undefined' ){
	        			return '/view/templates/profilepic-' + scope.type + '-css.html';
	        		} else {
	        			return '/view/templates/profilepic-' + scope.type + '.html';
	        		}


	            }

	        	function isRetina(){
	        	    return ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)').matches)) || (window.devicePixelRatio && window.devicePixelRatio >= 2)) && /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
	        	}

	        },

	        template: '<div ng-include="getContentUrl()" style="height:{{imgsize}}px;"></div>'
	    };



	}

	angular.module('SUGApp')
	.directive( 'profilePic', profilePic );

}());


// fb_userid = 617313591
